import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const { enFillers, enFillersWrong } = el;

  const wrong = enFillersWrong.split('\n');
  const enfillersShuffled = [enFillers].concat(wrong).filter((filler: string) => filler);

  return {
    ...el,
    enFillersShuffled: shuffle(enfillersShuffled),
  };
};
